import { Flex, Form, Typography, Button } from 'antd'
import { FC, useEffect, useState } from 'react'
import { relayStore } from '../../store/relay'
import { Relay, RelayOne, RelayType } from '../../helpers/types/relay'
import { useNavigate, useParams } from 'react-router-dom'
import { RNRelayOneRecords, RNRelay, RNRelayType } from '../../helpers/routeNames'
import { PageBreadcrumb } from '../../components/PageBreadcrumb'
import { CharacteristicCard } from '../../components/CharacteristicCard'

export const CreateRelayOneRecord: FC = () => {
	const { relayTypes, relayOnes, createRecord } = relayStore()
	const [form] = Form.useForm()

	const { Title } = Typography

	const { relayId, relayTypeId, relayOneId } = useParams<{
		relayId: string
		relayTypeId: string
		relayOneId: string
	}>()

	const [relayType, setRelayType] = useState<RelayType>()
	const [relay, setRelay] = useState<Relay>()
	const [relayOne, setRelayOne] = useState<RelayOne>()

	const navigate = useNavigate()

	useEffect(() => {
		if (relayTypes.length && relayOnes.length) {
			if (relayTypeId) {
				setRelayType(
					relayTypes.find((rt) => rt.id === relayTypeId)
				)
			}
			if (relayId) {
				setRelay(
					relayType?.relays.find((r) => r.id === relayId)
				)
			}
			if (relayOneId) {
				setRelayOne(
					relayOnes.find((ro) => ro.id === relayOneId)
				)
			}
		}
	}, [
		relayType,
		relay,
		relayOne,
		relayTypeId,
		relayId,
		relayOneId,
		relayTypes,
		relayOnes
	])

	if (
		!relay ||
		!relayType ||
		!relayOne ||
		!relayOneId ||
		!relayId ||
		!relayTypeId
	) {
		return <div>Реле, тип реле или реле не найдено</div>
	}

	return (
		<Flex vertical>
			<PageBreadcrumb
				items={[
					{ label: 'Типы реле', path: RNRelayType },
					{ label: relayType.name, path: RNRelayType + '/' + relayTypeId },
					{ label: relay.name, path: RNRelay + '/' + relayId },
					{
						label: 'Записи',
						path: RNRelayOneRecords + '/' + relayTypeId + '/' + relayId + '/' + relayOneId
					},
					{ label: 'Создать запись' }
				]}
			/>
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<Title level={2}>
					Добавление механических значении к {relay.name}
				</Title>
			</header>
			<main>
				<CharacteristicCard
					title="Информация о типе реле"
					data={[
						{ label: 'Название', value: relayType.name },
						{
							label: 'Реле',
							value: relayType.relays.length
						},
						{
							label: 'Механика',
							value: relayType.mechanics.length
						},
						{
							label: 'Электрика',
							value: relayType.electrics.length
						},
						{
							label: 'Дата создания',
							value: new Date(
								relayType.createdAt
							).toLocaleString('ru')
						}
					]}
				/>

				<CharacteristicCard
					title="Информация о реле"
					data={[
						{ label: 'Название', value: relay.name },
						{
							label: 'Срок службы',
							value: relay.expiration
						},
						{
							label: 'Дата создания',
							value: relay.createdAt
						},
						{ label: 'Тип реле', value: relayType.name }
					]}
				/>

				<CharacteristicCard
					title="Информация об экземпляре реле"
					data={[
						{
							label: 'Год выпуска',
							value: relayOne.madeYear
						},
						{
							label: 'Уникальный номер',
							value: relayOne.relayUnique
						},
						{
							label: 'Дата создания',
							value: new Date(
								relayOne.createdAt
							).toLocaleString('ru')
						}
					]}
				/>

				<Form
					form={form}
					layout="vertical"
					title="Механические характеристики"
					onFinish={async () => {
						await createRecord({
							relayTypeId,
							relayId,
							relayOneId
						})
						navigate(
							RNRelayOneRecords +
								'/' +
								relayTypeId +
								'/' +
								relayId +
								'/' +
								relayOneId
						)
					}}>
					<p>
						Вы уверены, что хотите добавить новую проверку
						характеристики реле с наименованием{' '}
						{relay.name}?
					</p>
					<Button type="primary" htmlType="submit">
						Добавить
					</Button>
				</Form>
			</main>
		</Flex>
	)
}
